"use client";

import { ActivityDisplayPreview } from "./previews";

type TrekkingDisplayProps = {
  data: Record<string, unknown> | null;
  participants: {
    id: string;
    displayName: string;
    avatarUrl: string | null;
    username: string | null;
  }[];
};

export function TrekkingDisplay({ data, participants }: TrekkingDisplayProps) {
  return (
    <ActivityDisplayPreview
      activityId="trekking"
      data={data}
      participants={participants}
    />
  );
}
